import React from "react";

import Block from "Components/UI/Block/Block";

import styles from "./FaultRulesDashboard.module.scss";
import FaultRulesList from "../FaultRulesList/FaultRulesList";

// Rules are created from the page header (Pages/Faults/FaultRules).
const FaultRuleDashboard = () => (
  <Block className={styles.faults}>
    <FaultRulesList />
  </Block>
);

export default FaultRuleDashboard;
